import { render, staticRenderFns } from "./ChatHistoryPanel.vue?vue&type=template&id=36a90c99&scoped=true&"
import script from "./ChatHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./ChatHistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatHistoryPanel.vue?vue&type=style&index=0&id=36a90c99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a90c99",
  null
  
)

export default component.exports